import * as ProjectActions from 'app/core/store/actions/noms/project.actions';
import { initialState } from '../../states/noms/project.states';


export type Action = ProjectActions.All

export function reducer(state = initialState, action: Action) {
    switch (action.type) {
        case ProjectActions.GET_LIST_OPTIONS_SUCCESS : {
            return {
                ...state,
                listOptions: action.payload
            }
        }

        default: return state
    }
}
